// Utility function to deeply compare DMN structures for changes
function isDmnChanged(currentXmlValue, previousXmlValue) {
  if (!currentXmlValue || !previousXmlValue) return false;

  // Compare inputFields keys
  const getFieldNames = (fields) => (fields || []).map((f) => f.name).sort();
  const currentInputKeys = getFieldNames(currentXmlValue.inputFields);
  const previousInputKeys = getFieldNames(previousXmlValue.inputFields);

  const currentOutputKeys = getFieldNames(currentXmlValue.outputFields);
  const previousOutputKeys = getFieldNames(previousXmlValue.outputFields);

  // If input or output field keys differ, DMN changed
  if (
    JSON.stringify(currentInputKeys) !== JSON.stringify(previousInputKeys) ||
    JSON.stringify(currentOutputKeys) !== JSON.stringify(previousOutputKeys)
  ) {
    return true;
  }

  // Compare data values for each key in inputFields and outputFields
  const keysToCheck = [...currentInputKeys, ...currentOutputKeys];

  // Helper to get value for a key in a data row
  const getValue = (row, key) => row[key];

  // Compare each row in data arrays
  const currentData = currentXmlValue.data || [];
  const previousData = previousXmlValue.data || [];

  // If data length differs, DMN changed
  if (currentData.length !== previousData.length) {
    return true;
  }

  for (let i = 0; i < currentData.length; i += 1) {
    const currRow = currentData[i];
    const prevRow = previousData[i];
    if (
      keysToCheck.some(
        (key) => getValue(currRow, key) !== getValue(prevRow, key)
      )
    ) {
      return true;
    }
  }

  // No changes found
  return false;
}

export default isDmnChanged;
